import { ICSSInJSStyle } from "@fluentui/react-northstar";
import { CSSProperties } from "react";

import { useFluentColorScheme } from "../../shared/theme/useColorScheme";
interface PermissionDeniedStyles {
  container: ICSSInJSStyle;
  connectionIcon: ICSSInJSStyle;
  headerLabel: ICSSInJSStyle;
  descriptionLabel: ICSSInJSStyle;
  privacyLink: CSSProperties;
}

export const usePermissionDeniedStyles: () => PermissionDeniedStyles = () => {
  const { main, white } = useFluentColorScheme();
  const label: ICSSInJSStyle = {
    color: white.foreground,
    backgroundColor: "transparent",
  };
  return {
    container: {
      width: "100%",
      height: "100%",
      backgroundColor: main.background,
    },
    connectionIcon: {
      width: "200px",
      height: "200px",
    },
    headerLabel: {
      ...label,
      height: "100%",
    },
    descriptionLabel: {
      ...label,
      height: "100%",
      width: "314px",
    },
    privacyLink: {
      color: main.foreground1,
      textDecoration: "underline",
    },
  };
};
